import { render, staticRenderFns } from "./AppTypeUpdate.vue?vue&type=template&id=503499d1&scoped=true"
import script from "./AppTypeUpdate.vue?vue&type=script&lang=js"
export * from "./AppTypeUpdate.vue?vue&type=script&lang=js"
import style0 from "./AppTypeUpdate.vue?vue&type=style&index=0&id=503499d1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "503499d1",
  null
  
)

export default component.exports